/** Booking display text is not an instant, even if it has a structural Z/offset. */
export function parseBookingWallClock(value: unknown): { date: Date; timed: boolean; stamp: string } | null {
  if (typeof value !== "string") return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,6}))?)?(?:Z|[+-](?:[01]\d|2[0-3]):?[0-5]\d)?)?$/.exec(value.trim());
  if (!m) return null;
  const [, y, mo, day, h, min, sec, fraction] = m;
  const d = new Date(0);
  d.setUTCFullYear(Number(y), Number(mo) - 1, Number(day));
  d.setUTCHours(Number(h ?? 0), Number(min ?? 0), Number(sec ?? 0), Number((fraction ?? "").slice(0, 3).padEnd(3, "0")));
  if (d.getUTCFullYear() !== Number(y) || d.getUTCMonth() + 1 !== Number(mo) ||
      d.getUTCDate() !== Number(day) || d.getUTCHours() !== Number(h ?? 0) ||
      d.getUTCMinutes() !== Number(min ?? 0) || d.getUTCSeconds() !== Number(sec ?? 0)) return null;
  return { date: d, timed: h != null, stamp: h == null ? value.trim() : d.toISOString() };
}
